import styled from 'styled-components';
import { FloatingOverlay as FloatingOverlayBase } from '@floating-ui/react';
export const ModalBase = styled.div `
  background: var(--color-background);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 672px;
  max-height: calc(100vh - 80px);
  width: 100%;
  z-index: 3;

  @media only screen and (max-width: 672px) {
    max-height: calc(100vh - 32px);
  }

  /* Trick to target only iOS Safari */
  @supports (-webkit-touch-callout: none) {
    max-height: -webkit-fill-available;
  }
`;
export const HeadingBase = styled.div `
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  justify-content: space-between;
  padding: 32px;

  & > h3 {
    flex: 1;
  }

  & > button {
    color: var(--color-on-background);
  }
`;
export const Content = styled.div `
  box-sizing: border-box;
  overflow: auto;
  padding: 24px 32px;

  background:
    linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */
      radial-gradient(
        50% 0,
        farthest-side,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      ),
    radial-gradient(
        50% 100%,
        farthest-side,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background: /* Shadow covers */
    linear-gradient(white 30%, rgba(255, 255, 255, 0)),
    linear-gradient(rgba(255, 255, 255, 0), white 70%) 0 100%,
    /* Shadows */
      radial-gradient(
        farthest-side at 50% 0,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      ),
    radial-gradient(
        farthest-side at 50% 100%,
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size:
    100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
  background-attachment: local, local, scroll, scroll;
`;
export const Footer = styled.div `
  border-top: 1px solid var(--color-border);
  padding: 32px;
`;
export const FloatingOverlay = styled(FloatingOverlayBase) `
  background: var(--color-scrim);
  display: grid;
  padding: 16px;
  place-items: center;
  z-index: 2;

  /**
   * Remove padding on small screens to save space.
   */
  @media only screen and (max-width: 374px) {
    padding: 0;
  }

  @media (prefers-reduced-motion) {
    animation: none !important;
    transition: none !important;
  }
`;
